// src/hooks/useDebounce.js
import { useState, useEffect } from 'react';

/**
 * Hook qui debounce une valeur.
 * @param {*} value - La valeur à débattre.
 * @param {number} delay - Le délai en millisecondes.
 * @returns {*} - La valeur débattue.
 */
export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Met à jour la valeur débattue après le délai
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Annule le timeout si la valeur change (l'utilisateur continue de taper)
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}